import { firestoreRef, authObj, authRef, getRoll } from "api";
import { updateProfileData } from "modules/profile/firebase";

export const googleSignInProvider = new authObj.GoogleAuthProvider();
export const facebookSignInProvider = new authObj.FacebookAuthProvider();

export async function addUserToFirestore(user, completed) {
  console.log(new Date().getTime());
  var firestoreUser =
    (await firestoreRef
      .collection("users")
      .doc(user.uid)
      .get()).data() || {};
  console.log(new Date().getTime());

  let fU = {
    name: user.displayName,
    photo_url: user.photoURL,
    email: user.email,
    provider_id: "",
    completed: firestoreUser.completed || false,
    uid: user.uid,
    phone: user.phone || user.phoneNumber || "",
    emailVerified: user.emailVerified,
    disabled: firestoreUser.disabled || false,
    lastSignedIn: new Date(
      user.metadata.lastSignInTime || new Date()
    ).getTime(),
    anon: user.isAnonymous,
    createdAt: new Date(user.metadata.creationTime || new Date()).getTime()
  };

  console.log(new Date().getTime());
  if (!firestoreUser.roll) {
    let roll = await getRoll({
      name: user.isAnonymous ? "anon" : user.displayName
    });
    fU["roll"] = roll.data;
  } else {
    fU["roll"] = firestoreUser.roll;
  }
  console.log(new Date().getTime());
  await firestoreRef
    .collection("users")
    .doc(user.uid)
    .set(fU, { merge: true });

  console.log(new Date().getTime());
  return fU;
}

export async function getUser(uid) {
  let res = await firestoreRef
    .collection("users")
    .doc(uid)
    .get();
  return res.data();
}

export async function signin(creds) {
  return authRef.signInWithEmailAndPassword(creds.email, creds.password);
}

export async function sendVerificationCode(phoneNumber, recaptchaVerifier) {
  return authRef.currentUser.linkWithPhoneNumber(
    phoneNumber,
    recaptchaVerifier
  );
}

export async function createUserWithEmailAndPassword(email, password) {
  await authRef.createUserWithEmailAndPassword(email, password);
}

export async function completeSignup(params) {
  await authRef.currentUser.updateProfile({
    displayName: params.name,
    photoURL: params.photo_url
  });
  await addUserToFirestore(authRef.currentUser, true);
  await updateProfileData(authRef.currentUser.uid, { phone: params.phone });
  return;
}

export async function signUp(params) {
  await createUserWithEmailAndPassword(params.email, params.password);
  await authRef.currentUser.updateProfile({
    displayName: params.name,
    photoURL: params.photo_url
  });
  await firestoreRef
    .collection("users")
    .doc(authRef.currentUser.uid)
    .set(
      {
        name: params.name,
        photo_url: params.photo_url,
        email: params.email,
        provider_id: "",
        completed: true,
        uid: authRef.currentUser.uid,
        phone: params.phone,
        emailVerified: false,
        disabled: false,
        lastSignedIn: new Date().getTime(),
        anon: false,
        createdAt: new Date().getTime(),
        roll: await getRoll({
          name: params.name
        })
      },
      { merge: true }
    );
  return;
}

export async function forgotPassword(email) {
  return await authRef.sendPasswordResetEmail(email);
}
